export default "__VITE_ASSET__BSFECUaF__"